import { useEffect } from 'react';
import { AutocompleteInput, Filter, useListController, useTranslate } from 'react-admin';
import dayjs from 'dayjs';
import { GameIds } from 'src/configs/game.config';
import FilterGroup from 'src/pages/admin/components/FilterGroup';
import CGFilterAgency from 'src/pages/admin/components/CGFilterAgency';
import { SelectGameInput } from 'src/pages/admin/components/common';
import CGTextInput from 'src/pages/admin/components/CGTextInput';
import { CgDateTimeInput } from 'src/pages/admin/components/CgDateTimeInput';
import {
  boOpenTransactionType,
  closeTransactionType,
  gameResultOptions,
  hashResultOptions,
  openTransactionType,
} from 'src/pages/admin/providers/constants';

const gameWithTieResult = [GameIds.H_NIUNIU, GameIds.H_BP];

function HistoryFilter(props: any) {
  const isFutureGame = props.gameId === GameIds.C_FUTURE;
  const isBoGame = props.gameId === GameIds.C_BO;
  const isRocketGame = props.gameId === GameIds.H_ROCKET;

  const { filterValues, setFilters } = useListController();

  useEffect(() => {
    // set default value for filter fromTime
    if (!filterValues.fromTime || !filterValues.timeTo) {
      setFilters({
        ...filterValues,
        fromTime: filterValues.timeTo
          ? dayjs(filterValues.timeTo).subtract(1, 'month').toISOString()
          : dayjs().subtract(1, 'month').toISOString(),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const filter = { ...filterValues };
    if (isFutureGame) {
      if (!filter.result) return;
      delete filter.result;
    } else {
      if (!filter.openType && !filter.closeType) return;
      delete filter.openType;
      delete filter.closeType;
    }
    setFilters(filter);
  });

  const t = useTranslate();

  const buildStatusChoices = () => {
    if (isFutureGame) {
      return [
        { id: 'Pending', name: t('module.game.status.Pending') },
        { id: 'Filled', name: t('module.game.status.Filled') },
        { id: 'Exit', name: t('module.game.status.Exit') },
      ];
    }

    if (isRocketGame) {
      return [
        { id: 'Running', name: t('module.game.status.Running') },
        { id: 'End', name: t('module.game.status.Finished') },
      ];
    }

    return [
      { id: 'Pending', name: t('module.game.status.Pending') },
      { id: 'Finished', name: t('module.game.status.Finished') },
    ];
  };

  return (
    <Filter {...props}>
      <FilterGroup alwaysOn>
        <CGFilterAgency source="agencyIds" label="module.user.agency" multiple={false} alwaysOn />
        <SelectGameInput source="games" label="module.user.games" alwaysOn />
        <CGTextInput label="module.game.searchOrderId" source="orderId" alwaysOn />

        <CGTextInput label="module.game.searchUserName" source="q" alwaysOn />
        <CGTextInput label="module.game.searchUserId" source="playerIds" value="" alwaysOn />
        {isBoGame
          ? [
              <AutocompleteInput
                label="module.game.openType"
                source="openType"
                choices={boOpenTransactionType}
                alwaysOn
              />,
            ]
          : isFutureGame
            ? [
                <AutocompleteInput
                  label="module.game.openType"
                  source="openType"
                  choices={openTransactionType}
                  alwaysOn
                />,
                <AutocompleteInput
                  label="module.game.closeType"
                  source="closeType"
                  choices={closeTransactionType}
                  alwaysOn
                />,
              ]
            : [
                <AutocompleteInput
                  label="resource.result"
                  source="result"
                  choices={
                    gameWithTieResult.includes(props.gameId)
                      ? gameResultOptions
                      : hashResultOptions
                  }
                  alwaysOn
                />,
              ]}

        <AutocompleteInput
          label="module.game.searchOrderStatus"
          source="status"
          choices={buildStatusChoices()}
          alwaysOn
        />
        <CGTextInput label="module.game.betAmountFrom" source="fromAmount" alwaysOn />
        <CGTextInput label="module.game.betAmountTo" source="toAmount" alwaysOn />
        <CgDateTimeInput
          label="module.game.timeFrom"
          source="fromTime"
          alwaysOn
          sx={{ width: 230 }}
        />
        <CgDateTimeInput
          label="module.game.timeTo"
          source="toTime"
          minDate={filterValues?.fromTime ? dayjs(filterValues.fromTime) : undefined}
          type="to"
          alwaysOn
          sx={{ width: 230 }}
        />
      </FilterGroup>
    </Filter>
  );
}

export default HistoryFilter;
